import { trackEcommerce, trackingConstants, eventNameConstants } from 'dibs-tracking';

const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST } = eventNameConstants;

export const trackPdpRedirect =
    (
        nftItemId: string | null,
        nftItemName: string | null | undefined,
        index: number,
        tabName: string
    ) =>
    (): void => {
        const list = `nft profile - ${tabName.toLowerCase()}`;

        trackEcommerce({
            type: ECOM_PRODUCT_CLICK,
            eventName: EVENT_SELECT_ITEM,
            actionField: { list, itemId: nftItemId },
            products: [
                {
                    category: '/nft/art/',
                    name: nftItemName,
                    id: nftItemId,
                    position: index,
                    list,
                    variant: 'nft profile',
                },
            ],
        });
    };

export const trackPdpImpression =
    (
        nftItemId: string | null,
        nftItemName: string | null | undefined,
        index: number,
        tabName: string
    ) =>
    (): void => {
        trackEcommerce({
            type: ECOM_PRODUCT_IMPRESSION,
            eventName: EVENT_VIEW_ITEM_LIST,
            products: [
                {
                    category: '/nft/art/',
                    name: nftItemName,
                    id: nftItemId,
                    position: index,
                    list: `nft profile - ${tabName.toLowerCase()}`,
                    variant: 'nft profile',
                },
            ],
        });
    };
